<script lang="ts">
	import Katex from './Katex.svelte';
	import uqnSplit from './functions/uqnSplit';
	import Fraction from './functions/fractionClass';
	import polyBuilder from './functions/polyBuilder';
	//import fractionBuilder from './functions/fractionBuilder';
	//import signAssign from './functions/signAssign';
	import Chart from './Chart.svelte';
	//import brackets from './functions/brackets';

	export let uqn: number;
	let bAns: string, cAns: string, type:string;
	$: [bAns, cAns, type] = uqnToQn(uqn);

	function uqnToQn(u:number):string[]{
		let bAns = "", cAns = "";
		let [t,a,b,c] = uqnSplit(u);
		if (t==1 || t==2){
			const aOverB = new Fraction(a,b).simplify().toString();
			const A = t==1? new Fraction(a*(10-c),10*b).simplify().toString() : new Fraction(a*(c),10*b).simplify().toString();
			const minusBT = polyBuilder([-b],"t",1);
			const sign = t==1? "-" : "+";
			bAns = `m=${aOverB+sign+A} e^{${minusBT}}.`;
			cAns = aOverB;
		} else if (t==3){
			const bQn = new Fraction(b,10).simplify();
			const aOverB = new Fraction(a,1).divide(b).toString();
			const AFrac = new Fraction(a*(c-10),10).divide(bQn);
			const A = AFrac.toString();
			const bT = polyBuilder([b],'t',1);
			bAns = `m=${aOverB+A} e^{${bT}}`;
			cAns = "t=" + (Math.log(-10/(c-10))/bQn.eval()).toPrecision(3);
		} else {
			const aOverB = new Fraction(a,b).simplify().toString();
			const AFrac = new Fraction(a*(c),10).divide(b);
			const A = AFrac.toString();
			const bT = polyBuilder([b],'t',1);
			bAns = `m=${aOverB+'+'+A} e^{${bT}}`;
		}		
		return [bAns, cAns,t.toString()];
	}

</script>

<p> 
	(b) <Katex math={bAns}/>
</p>
<p>
	{#if type == '1' || type=='2'}
	(c) The mass approaches <Katex math={cAns}/> g eventually.
	{:else if type=='3'}
	(c) <Katex math={cAns}/> s.
	{:else}
	(c) As <Katex math={"t \\to \\infty, \\allowbreak m \\to \\infty"}/> but this is unrealistic as the bacteria cannot grow indefinitely in the real world.
	{/if}
</p>
<div>(d) <Chart uqn={uqn}/></div>